import durationToast from "../data/toastDuration";

function setupToast(dispatch, type, title, message, duration = durationToast, deleteTime = undefined) {
    const id = Math.random().toString(36).substr(2, 9);
    deleteTime = deleteTime != undefined ? deleteTime : duration;

    const toast = { type, message, id, title, duration, deleteTime };
    dispatch({ type: 'addToast', payload : { toast } });
    
    if(deleteTime != 0) {
        setTimeout(() => { dispatch({ type: 'deleteToast', payload : { id } }) }, deleteTime);
    }
    
    return toast;
}

export default setupToast;
